import axios from "axios";
export default {
    getSummaryReportDetails: (summaryReportId) => axios.post("/SummaryReports/GetSummaryReportDetails", { Id: summaryReportId }),
    saveSummaryReportDetails: (data) => axios.post("/SummaryReports/SaveSummaryReportDetails", data)
};
